var map = {
	"./google-play-badge-DE.png": [
		17792,
		[
			7792
		]
	],
	"./google-play-badge-EN.png": [
		71484,
		[
			1484
		]
	],
	"./google-play-badge-ES.png": [
		78921,
		[
			8921
		]
	],
	"./google-play-badge-FR.png": [
		64177,
		[
			4177
		]
	],
	"./google-play-badge-IT.png": [
		1090,
		[
			1090
		]
	],
	"./google-play-badge-NL.png": [
		43191,
		[
			3191
		]
	],
	"./google-play-badge-PT.png": [
		84221,
		[
			4221
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 14281;
module.exports = webpackAsyncContext;